"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LetsDiscussYourGoals() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221787" id="intelligence-team-e-padronanza-algoritmica" className="bg-background relative flex min-h-[60vh] items-center justify-center px-6 py-24 md:py-32 lg:py-40 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1591142/img/cyber_mesh_pattern.png')] bg-repeat"></div>
      
      <div ref={ref} className={`mx-auto max-w-4xl text-center transition-all duration-1000 ease-out relative z-10 ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none pointer-events-none">
          <span className="text-[12rem] md:text-[20rem] font-default font-black text-transparent border-primary/20 [text-stroke:2px_hsl(var(--primary))] opacity-10">
            15+
          </span>
        </div>

        <span className="mb-4 block text-sm font-mono tracking-[0.3em] uppercase text-secondary">
          [ OPERATIONAL_HISTORY_CIS ]
        </span>
        <h1 className="font-default mb-8 text-4xl leading-tight font-black tracking-tighter text-foreground md:text-5xl lg:text-7xl uppercase">
          Intelligence Team e Padronanza Algoritmica
        </h1>
        <p className="mx-auto mb-12 max-w-2xl font-default text-xl leading-relaxed text-muted-foreground md:text-2xl">
          Oltre 15 anni di leadership tecnica nel mercato SEO della Federazione Russa. 
          Garantiamo l'accessibilità e il posizionamento strategico nei corridoi digitali CSI attraverso infrastrutture native.
        </p>
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <Button asChild size="lg" className="h-14 rounded-none px-10 text-base tracking-widest font-default font-bold bg-primary text-primary-foreground hover:bg-primary/90 transition-colors">
            <Link to="/ContactPage">RICHIEDI ACCESSO</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-14 rounded-none border-secondary/50 bg-transparent px-10 text-base tracking-widest font-default text-secondary hover:bg-secondary hover:text-secondary-foreground transition-all">
            <Link to="/AboutUsPage">SCOPRI IL DOSSIER</Link>
          </Button>
        </div>
      </div>
    </section>;
}